export class AuditSummaryFormModel
{
    id: number = 0;
    categoryId: number = -1;
    categorySubCategoryId: number = -1;
    weightage: string;
    uiLayerRating: number = -1;
    middleAndDbLayerRating: number = -1;
    comments: string;
}